import * as React from "react";

function HandWaveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M304 32c26.5 0 48 21.53 48 48 0 8.84 7.2 16 16 16s16-7.16 16-16c0-44.11-35.9-80-80-80-8.8 0-16 7.156-16 16s7.2 16 16 16zM80 416c-26.47 0-48-21.5-48-48 0-8.8-7.16-16-16-16s-16 7.2-16 16c0 44.1 35.88 80 80 80 8.84 0 16-7.2 16-16s-7.16-16-16-16zM472 96c-22.1 0-39.1 17.9-39.1 39.1v81.8L234.4 19.3c-6.2-6.25-15.3-9.373-22.6-9.373-18.3 0-31.1 14.96-31.1 31.1 0 8.19 3.124 16.38 9.372 22.63l124.5 124.5a15.951 15.951 0 0 1 4.685 11.31c0 9.156-7.482 15.1-15.1 15.1-4.095 0-8.19-1.562-11.31-4.686L143.9 64.55c-6.2-6.25-14.4-9.37-22.6-9.37-17.09 0-31.1 13.76-31.1 32 0 8.19 3.124 16.38 9.372 22.63L245.7 256.9a15.948 15.948 0 0 1 4.686 11.31c0 9.152-7.48 15.1-15.1 15.1a15.936 15.936 0 0 1-11.31-4.686L98.65 155.1c-6.25-6.3-14.44-9.4-22.63-9.4-18.31 0-32 14.97-32 31.1 0 8.19 3.124 16.38 9.372 22.63l124.5 124.5a15.948 15.948 0 0 1 4.686 11.31c0 8.545-6.877 15.1-15.1 15.1a15.94 15.94 0 0 1-11.31-4.685L76.03 268.2c-6.25-7.1-14.44-9.4-22.63-9.4-17.09 0-32 13.76-32 32 0 8.19 3.124 16.38 9.372 22.63l147.1 147.1c34.31 34.31 79.38 51.47 124.5 51.47s90.14-17.16 124.5-51.47l26.67-26.67C491.2 396.1 512 345.9 512 292.5V135.1c0-21.2-17.9-39.1-40-39.1z"
  }));
}

const ForwardRef = React.forwardRef(HandWaveIcon);
export default ForwardRef;